// export const BE_URL = "http://localhost:8080/BookStore/api/";
export const BE_URL =
  "https://bookoryspringboot-production.up.railway.app/api/";
export const KEY_ACCESS_TOKEN = "accessToken";
export const KEY_IS_LOGGER = "isLogin";
export const KEY_USER = "user";
// export const IMG_URL = "http://localhost:8080/BookStore/api/image/";
export const IMG_URL =
  "https://bookoryspringboot-production.up.railway.app/api/image/";
// export const IMG_URL =
//   "https://bookoryspringboot-production.up.railway.app/api/image/";
